import React from "react";
import { Body, Headline, IconAppStore, IconGooglePlay } from "@web-monorepo/mds";
import { logSparksEvent } from "@src/utils/sparks/logSparksEvent";
import type { FeatureSupportValue } from "@src/utils/sparks/parseFeatureSupportStatus";
import { getPlatformMessage } from "./constants";

type Platform = "android" | "ios";

type Props = {
  platform: Platform;
  title: string;
  support: FeatureSupportValue;
  minVersion: string;
  storeUrl: string;
};

export const SparksPlatformSupportCard = ({ platform, title, support, minVersion, storeUrl }: Props) => {
  const handleStoreClick = () => {
    void logSparksEvent({
      eventName: "web.external_page.sparks.feature_support.store_click",
      eventValue: platform,
    });
  };

  return (
    <div className="flex flex-col items-center gap-y-md text-center">
      <Headline as="h2" size="4" weight="bold">
        {title}
      </Headline>
      <Body size="2" weight="bold" className="max-w-320">
        {getPlatformMessage(support, minVersion)}
      </Body>

      {support.status === "available" && (
        <>
          <a href={storeUrl} target="_blank" rel="noreferrer" onClick={handleStoreClick}>
            {platform === "android" ? (
              <IconGooglePlay variant="fillBlackColor" className="h-48 w-auto" />
            ) : (
              <IconAppStore className="h-48 w-auto" />
            )}
          </a>
          <Body size="2" className="text-content-secondary">
            update the ClassDojo app
          </Body>
        </>
      )}
    </div>
  );
};
